import { render } from "./AddApp.vue?vue&type=template&id=17645353"
import script from "./AddApp.vue?vue&type=script&lang=js"
export * from "./AddApp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__